import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import AnchorNav from '@/components/feature/AnchorNav';
import MangakuHero from './components/MangakuHero';
import MangakuCards from './components/MangakuCards';
import MangakuInfo from './components/MangakuInfo';
import MangakuContact from './components/MangakuContact';
import MangakuSeoJsonLd from './components/MangakuSeoJsonLd';

export default function MangakuPage() {
  useEffect(() => {
    document.title = 'まんがく | 高松 ポケモンカード・トレーディングカード専門店 - 買取・販売';
    const mangakuOgImage = 'https://public.readdy.ai/ai/img_res/11d31c13fbaf1067acf26eff622421b4.jpg';
    const metas: { name?: string; property?: string; content: string }[] = [
      { name: 'description', content: '香川県高松市のトレーディングカード専門店「まんがく」。ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツの買取・販売。高松市瓦町2-1-28 高尾ビル2F南。' },
      { name: 'keywords', content: '高松 ポケモンカード,まんがく,カードショップ 高松,ポケモンカード買取 高松,ワンピースカード 高松,トレーディングカード 香川,カード買取 高松市,ポケカ 高松' },
      { property: 'og:title', content: 'まんがく | 高松 ポケモンカード・トレーディングカード専門店' },
      { property: 'og:description', content: '香川県高松市のトレーディングカード専門店。ポケモンカード・ワンピースカードなど人気TCGの買取・販売。' },
      { property: 'og:url', content: 'https://botan-buy.com/mangaku' },
      { property: 'og:image', content: mangakuOgImage },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: mangakuOgImage },
      { name: 'twitter:title', content: 'まんがく | 高松 ポケモンカード・トレーディングカード専門店' },
      { name: 'twitter:description', content: '香川県高松市のトレーディングカード専門店。ポケモンカード・ワンピースカードなど人気TCGの買取・販売。' },
      { name: 'geo.region', content: 'JP-37' },
      { name: 'geo.placename', content: '高松市' },
      { name: 'geo.position', content: '34.3401;134.0434' },
    ];
    metas.forEach(({ name, property, content }) => {
      const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let el = document.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = document.createElement('meta');
        if (name) el.setAttribute('name', name);
        if (property) el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prev = canonical?.getAttribute('href') ?? '';
    if (canonical) canonical.setAttribute('href', 'https://botan-buy.com/mangaku');
    return () => {
      document.title = '株式会社BotaN | 買取専門店天神屋・カードショップまんがく';
      if (canonical) canonical.setAttribute('href', prev);
    };
  }, []);

  return (
    <div className="font-sans">
      <MangakuSeoJsonLd />
      <Navbar />
      <div className="pt-20">
        <Breadcrumb items={[{ label: 'カードショップ まんがく' }]} />
      </div>
      <main>
        <MangakuHero />
        <AnchorNav
          accentColor="text-red-600"
          items={[
            { icon: 'ri-gamepad-line', label: '取扱カード', href: '#cards' },
            { icon: 'ri-store-line', label: '店舗情報', href: '#info' },
            { icon: 'ri-phone-line', label: 'お問い合わせ', href: '#contact' },
          ]}
        />
        <MangakuCards />
        <MangakuInfo />
        <MangakuContact />
      </main>
      <Footer />
    </div>
  );
}
